<template>
    <div>
        <v-tooltip 
            content-class="left"
            v-if="!isPanelHidden"
            left
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="minimize-studio white pa-0"
                    large
                    v-bind="attrs"
                    v-on="on"
                    @click.prevent="togglePanel"
                >
                    <v-icon class="icon mr-6">
                        icon-eye-closed
                    </v-icon>
                </v-btn>
            </template>
            <span>
                {{ $t('habiteoStudio.hidePanel') }}
            </span>
        </v-tooltip>

        <v-slide-x-reverse-transition>
            <div v-show="isPanelHidden">
                <v-btn
                    v-if="!isExportStep"
                    class="expand-studio white--text text-none"
                    color="green darken-1"
                    large
                    @click.prevent="togglePanel"
                >
                    <v-icon left>
                        icon-eye-opened
                    </v-icon>
                    {{ $t('habiteoStudio.openStudio') }}
                </v-btn>
                <div
                    v-else
                    class="toggle-last-step"
                >
                    <v-tooltip 
                        content-class="left" 
                        left
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="minimize-studio pa-0"
                                large
                                v-bind="attrs"
                                v-on="on"
                                @click.prevent="togglePanel"
                            >
                                <v-icon class="icon mr-6">
                                    icon-eye-opened
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{ $t('habiteoStudio.hidePanel') }}
                        </span>
                    </v-tooltip>
                    <v-card
                        id="export-card"
                        class="pa-5"
                    >
                        <v-btn
                            class="white--text text-none"
                            color="green darken-1"
                            x-large
                            :loading="loading"
                            :disabled="loading"
                            @click.prevent="startExport"
                        >
                            <v-icon left>
                                icon-download-file
                            </v-icon>
                            {{ $t('habiteoStudio.export') }}
                        </v-btn>
                    </v-card>
                </div>
            </div>
        </v-slide-x-reverse-transition>
    </div>
</template>

<script>
    export default {
        name: 'ToggleButton',
        props: {
            isPanelHidden: {
                type: Boolean,
                required: true
            },
            isExportStep: {
                type: Boolean,
                required: true
            },
            isFilenameFilled: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                loading: false
            };
        },
        methods: {
            togglePanel() {
                this.$emit('toggle-panel');
            },
            startExport() {
                this.$emit('start-export');
                if (!this.isFilenameFilled)
                    this.$emit('toggle-panel');
                else
                    this.loading = true;
            }
        },
        watch: {
            isExportStep() {
                this.loading = false;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/components/ToggleButton.vue